import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiFileText, FiBookOpen, FiUserPlus, FiRefreshCw } = FiIcons;

const reqConfig = {
  'Security Awareness': { icon: FiShield, color: 'bg-blue-50 text-blue-600 border-blue-100' },
  'Policy Acknowledgement': { icon: FiFileText, color: 'bg-purple-50 text-purple-600 border-purple-100' },
  'Compliance Training': { icon: FiBookOpen, color: 'bg-teal-50 text-teal-600 border-teal-100' },
  'Onboarding': { icon: FiUserPlus, color: 'bg-violet-50 text-violet-600 border-violet-100' },
  'Remedial': { icon: FiRefreshCw, color: 'bg-orange-50 text-orange-600 border-orange-100' },
};

const RequirementTypeSummary = ({ records = [] }) => {
  const types = [...new Set(records.map(r => r?.requirementType).filter(Boolean))];

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <h3 className="text-sm font-semibold text-slate-700 mb-4">By Requirement Type</h3>
      <div className="space-y-3">
        {types.length === 0 && <p className="text-sm text-slate-400">No requirement types found.</p>}
        {types.map(type => {
          const recs = records.filter(r => r?.requirementType === type);
          const compliant = recs.filter(r => r?.complianceStatus === 'Compliant').length;
          const overdue = recs.filter(r => r?.complianceStatus === 'Overdue').length;
          const pct = Math.round((compliant / recs.length) * 100);
          const cfg = reqConfig[type] || { icon: FiShield, color: 'bg-slate-50 text-slate-600 border-slate-100' };

          return (
            <div key={type} className={`flex items-center gap-3 p-3 rounded-lg border ${cfg.color}`}>
              <div className="w-8 h-8 rounded-lg bg-white/60 flex items-center justify-center flex-shrink-0">
                <SafeIcon icon={cfg.icon} className="text-sm" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-semibold text-slate-700 truncate">{type}</p>
                <div className="flex items-center gap-2 mt-1">
                  <div className="flex-1 bg-white/60 rounded-full h-1.5">
                    <div className="h-1.5 rounded-full bg-current opacity-70" style={{ width: `${pct}%` }} />
                  </div>
                  <span className="text-xs font-bold">{pct}%</span>
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-xs font-bold text-slate-700">{recs.length}</p>
                <p className="text-xs text-slate-500">records</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RequirementTypeSummary;